import { ToastMessage } from 'types';

export const getErrorMessage = (title = 'Error', message: string): ToastMessage<'error'> => ({
  title,
  message,
  options: { type: 'error' },
});

export const getSuccessMessage = (title: string, message: string): ToastMessage<'success'> => ({
  title,
  message,
  options: { type: 'success' },
});
